import { render, staticRenderFns } from "./NotificationHeaderChat.vue?vue&type=template&id=6d2b277a&scoped=true&"
import script from "./NotificationHeaderChat.vue?vue&type=script&lang=js&"
export * from "./NotificationHeaderChat.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHeaderChat.vue?vue&type=style&index=0&id=6d2b277a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b277a",
  null
  
)

export default component.exports